export default function DetallesBlue({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-center shrink-0 rounded-full border-none cursor-pointer touch-manipulation select-none transition-colors duration-200 ease-out active:scale-[0.97] [@media(hover:hover)]:hover:bg-[#0077ed]"
      style={{
        height: '44px',
        padding: '0 18px',
        backgroundColor: '#0071e3',
        fontSize: '14px',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        fontFamily: '"Public Sans", sans-serif',
        color: '#fff',
        whiteSpace: 'nowrap',
      }}
    >
      Ver detalles
    </button>
  );
}
